
import Vue from 'vue';

export default Vue.extend({
    name: 'BillingModal',
    props: {
        title: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            default: false,
        },
        saveDisabled: {
            type: Boolean,
            default: false,
        },

        denyButtonText: {
            type: String,
            default: null,
        },
        affirmButtonText: {
            type: String,
            default: null,
        },
        invertButtons: {
            type: Boolean,
            default: false,
        },

        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        completed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        deny(): string {
            return this.denyButtonText || this.$t('general.no').toString();
        },
        affirm(): string {
            return this.affirmButtonText || this.$t('general.yes').toString();
        },
    },
    methods: {
        handleKeyDown(evt: KeyboardEvent) {
            if (evt.key === 'Escape') this.$emit('close');
        },
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
});
